import { Icon } from "@chakra-ui/react";
import { TertiaryButton } from "components/Button";
import { LuCalendarPlus } from "react-icons/lu";

interface BaseTableButtonProps {
  onClick: () => void;
}

export function BaseScheduleTableButton({ onClick }: BaseTableButtonProps) {
  return (
    <TertiaryButton
      h="28px"
      rightIcon={<Icon as={LuCalendarPlus} boxSize="4" />}
      onClick={onClick}
    >
      Schedule
    </TertiaryButton>
  );
}
